// src/pages/Admin/views/verification-rules/components/CrudTable.jsx
import React from 'react';
import { Button } from '../../../components/ui/button'; // Adjust path


const CrudTable = ({
  items,
  columns,
  onDeleteItem, // This will now handle activate/deactivate
  editingItemId,
  onEditItem,
  onCancelEdit,
  onApplyEdit,
  // Styling props
  tableClassName = "min-w-full divide-y divide-gray-200",
  // ... other styling props
  actionCellClassName = "px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-2",
}) => {
  // ... (no items message) ...

  return (
    <div className="overflow-x-auto">
      <table className={tableClassName}>
        {/* ... (thead remains same) ... */}
        <thead className="bg-gray-50">
          <tr>
            {columns.map((col) => (
              <th key={col.key} scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {col.header}
              </th>
            ))}
            <th scope="col" className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {items.map((item) => {
            const currentItemKey = item.id || item.tempId;
            const isEditingThisRow = editingItemId === currentItemKey;

            return (
              <tr
                key={currentItemKey}
                className={`${isEditingThisRow ? "bg-blue-100" : "hover:bg-gray-50"}`}
              >
                {columns.map((col) => (
                  <td key={`${col.key}-${currentItemKey}`} className={`px-6 py-4 whitespace-nowrap ${col.cellCustomClass || ''}`}>
                    {typeof col.render === 'function' ? col.render(item) : <span className="text-sm">{item[col.key]}</span>}
                  </td>
                ))}
                <td className={actionCellClassName}>
                  {isEditingThisRow ? (
                    <>
                      <Button onClick={onApplyEdit} variant="green" size="sm" className="!p-2 !text-xs">Apply</Button>
                      <Button onClick={onCancelEdit} variant="outline" size="sm" className="!p-2 !text-xs !border-gray-400 !text-gray-600 hover:!bg-gray-100">Cancel</Button>
                    </>
                  ) : (
                    <>
                      <Button onClick={() => onEditItem(item)} variant="outline" size="sm" className="!p-2 !text-xs">Edit</Button>
                      <Button
                        onClick={() => onDeleteItem(item)}
                        variant="outline"
                        size="sm"
                        className={`!p-2 !text-xs ${item.is_active ? '!text-red-600 hover:!bg-red-50 !border-red-300' : '!text-green-600 hover:!bg-green-50 !border-green-300'}`}
                      >
                        {item.is_active ? 'Deactivate' : 'Activate'}
                      </Button>
                    </>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CrudTable;